export default `
	headline
	primaryImage {
		size
		width
		height
		filename
		url(transform:coverImage)
	}
	wordImageAssociation {
		...on WordImageAssociationItem {
			word
			image {
				filename
				height
				id
				size
				url
				width
			}
			wordIndex
			offsetX
			offsetY
			scale
		}
	}
`;
